<template>
    <Fragment>
        <Heading>{{ $t('excelImport') }}</Heading>
        
        <AntUpload
            :file-list="fileList"
            :remove="handleRemove"
            :before-upload="beforeUpload"
            accept=".xlsx"
        >
            <AntButton>{{ $t('chooseExcelFile') }} </AntButton>
        </AntUpload>

        <AntButton
            type="primary"
            :disabled="fileList.length === 0"
            :loading="uploading"
            style="margin-top: 16px"
            @click="handleUpload"
        >
            <template v-if="uploading">
                {{ $t('uploading') }}
            </template>
            <template v-if="!uploading">
                <AntIcon type="upload" /> {{ $t('startUpload') }}
            </template>
        </AntButton>
    </Fragment>
</template>

<script>
import Heading from '@/components/Heading.vue';
import { Upload, Button, Icon } from 'ant-design-vue';
import Vapor from 'laravel-vapor';

export default {
    components: {
        Heading,
        AntUpload: Upload,
        AntButton: Button,
        AntIcon: Icon,
    },
    data() {
        return {
            fileList: [],
            uploading: false,
        };
    },
    methods: {
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);

            this.fileList = newFileList;
        },
        beforeUpload(file) {
            this.fileList = [file];

            return false; // Stop Ant from uploading the file
        },
        async handleUpload() {
            this.uploading = true;

            try {
                const { uuid, key, bucket } = await Vapor.store(this.fileList[0], {
                    baseURL: process.env.VUE_APP_BASE_URL,
                    headers: {
                        common: {
                            Authorization: `Bearer ${this.$store.state.auth.token}`,
                        },
                    },
                });

                const { id, name } = await this.$http.post('/measures/import/excel', {
                    uuid,
                    path: key,
                    bucket,
                    name: this.fileList[0].name,
                    content_type: this.fileList[0].type,
                });

                this.$notification.success({
                    message: this.$t('successfullyUploadedMeasure', { measure: name }),
                });

                this.$router.push({ name: 'measures.view', params: { id } });
            } catch {
                this.$notification.error({
                    message: this.$t('somethingWentWrongWithUpload'),
                });
            }

            this.uploading = false;
        },
    },
};
</script>